import { render } from "./FloorplanView.vue?vue&type=template&id=391a0928"
import script from "./FloorplanView.vue?vue&type=script&lang=js"
export * from "./FloorplanView.vue?vue&type=script&lang=js"

import exportComponent from "F:\\PWAs\\riverlea-new-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__